@if (!navigationItemVisibilityService.isNavigationItemHidden(childNavigationItem)) {
  <li class="m-side-navigation__menuSubitem" role="none">
    <a
      (click)="navigationItemClickService.clickNavigationItem(childNavigationItem)"
      [ngClass]="{
        'selected-item':
          isSelected() &&
          !navigationItemVisibilityService.isContainingVisibleChildren(childNavigationItem),
        'cannot-drop': dragDropService.widgetIsDragging$ | async,
      }"
      [routerLink]="[childNavigationItem.routerLink || router.url]"
      class="m-side-navigation__link"
      role="menuitem"
      tabindex="-1"
    >
      <span class="m-side-navigation__label">
        {{
          childNavigationItem.nameKey
            ? (childNavigationItem.nameKey | translate)
            : childNavigationItem.name
        }}
      </span>
    </a>
  </li>
}
